import axios from "axios";
import { logout } from "../lib/auth";

import { EditDataDifine } from "../config/dataInterface";
import { CONST } from "../config/const";

// パートナ支払単価一覧取得
export async function getListIDs(id: string) {
  try {
    const path = "entrySaleCompanyPaymentListIDs";
    const params = { id };
    const response = await axios.get(CONST.apiUrl + path, {
      params,
    });
    if (response.data.fetch_data === "null") {
      return { sudDatas: [] };
    }
    return { sudDatas: response.data.fetch_data };
  } catch (error) {
    return { sudDatas: [] };
    // logout();
  }
}
// パートナ支払単価詳細編集
export async function putListID(editData: EditDataDifine) {
  try {
    const path = "entrySaleCompanyPaymentListID";
    const params = { id: editData.id };
    const bodys = {
      id: editData.id,
      key: editData.key,
      value: editData.value,
      editValue: editData.editValue,
    };
    const response = await axios.put(CONST.apiUrl + path, {
      params,
      bodys,
    });
    return response.data.edit;
  } catch (error) {
    // logout();
  }
}

// パートナ支払単価登録
export async function postListID(addData: {
  [key: string]: string | boolean | any[];
}) {
  try {
    const path = "entrySaleCompanyPaymentListID";
    const bodys = { addData };
    const response = await axios.post(CONST.apiUrl + path, {
      bodys,
    });
    return response.data.add;
  } catch (error) {
    // logout();
  }
}
